import {
  Breadcrumb,
  Row,
  Col,
  PageHeader,
  Form,
  Select,
  Popconfirm,
  Button,
  Input,
  DatePicker,
  message,
  Spin,
} from "antd";
import Page from "_components/Page";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { GuranteeType, TiepType } from "_helpers";
import { currencyService, guranteeService } from "_services";

function Add({ history }) {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [currencyTypes, setCurrencyTypes] = useState([]);
  const [usedGuranteesTypes, setUsedGuranteesTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAllCurrencyTypes();
    getAllGurantees();
  }, []);

  const getAllGurantees = () => {
    guranteeService.getAll().then((data) => {
      // Get used unique gurantee types from the fetched gurantees
      setUsedGuranteesTypes([
        ...new Set(data.content.map((item) => item.guranteeType)),
      ]);
    });
  };

  const getAllCurrencyTypes = () => {
    currencyService.getSuggestion().then((data) => {
      setCurrencyTypes(data.content);
    });
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Popconfirm
        title="Are you sure?"
        onConfirm={(e) => {
          handleFormSubmit();
        }}
        key="save-confirm"
      >
        <Button key="btn-save" type="primary" htmlType="submit">
          Save
        </Button>
      </Popconfirm>
    );
    buttons.push(
      <Button
        key="btn-cancel"
        htmlType="button"
        onClick={() => history.push(".")}
      >
        Cancel
      </Button>
    );

    return buttons;
  };

  const handleFormSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true);

        const payload = {
          ...values,
          validFrom: values.validFrom
            ? values.validFrom.format("YYYY-MM-DD")
            : null,
          validTo: values.validTo ? values.validTo.format("YYYY-MM-DD") : null,
          currency: { id: values.currency.id },
        };
        guranteeService
          .create(payload)
          .then((response) => {
            message.success("Successfully Created!", 3);
            setLoading(false);
            history.push("/gurantees");
          })
          .catch((error) => {
            message.error(error);
            setError(error);
            setLoading(false);
          });
      })
      .catch((error) => message.error(error));
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Heirachy</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/jobs">Gurantee Value</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Spin spinning={loading}>
            <Form
              layout="vertical"
              form={form}
              name="form"
              requiredMark={true}
              onFinish={handleFormSubmit}
            >
              <Row gutter={24}>
                <Col span={4}>
                  <Form.Item
                    name={["tiepType"]}
                    label="Tiep Type"
                    rules={[{ required: true, message: "Tiep Type Required" }]}
                  >
                    <Select>
                      {TiepType.map((type) => (
                        <Select.Option value={type.value} key={type.value}>
                          {type.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* <Col span={4}>
                  <Form.Item
                    name={["guranteeType"]}
                    label="Gurantee Type"
                    rules={[
                      { required: true, message: "Gurantee Type Required" },
                    ]}
                  >
                    <Select>
                      {GuranteeType.map((type) => (
                        <Select.Option value={type.value} key={type.value}>
                          {type.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col> */}

                <Col span={4}>
                  <Form.Item
                    name={["guranteeType"]}
                    label="Gurantee Type"
                    rules={[
                      { required: true, message: "Gurantee Type Required" },
                    ]}
                  >
                    {/* <Select>
                      {GuranteeType
                        // filter out the types that already exist in usedGuranteesTypes
                        .filter(
                          (type) => !usedGuranteesTypes.includes(type.value)
                        )
                        .map((type) => (
                          <Select.Option value={type.value} key={type.value}>
                            {type.name}
                          </Select.Option>
                        ))}
                    </Select> */}
                    <Select>
                      {GuranteeType.map((type) => (
                        <Select.Option value={type.value} key={type.value}>
                          {type.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item
                    name={["currency", "name"]}
                    label="Currency"
                    rules={[{ required: true, message: "Currency Required" }]}
                  >
                    <Select
                      onChange={(selected, option) =>
                        form.setFieldValue(["currency", "id"], option.key)
                      }
                    >
                      {currencyTypes?.map((type) => (
                        <Select.Option value={type.value} key={type.id}>
                          {type.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item name={["validFrom"]} label="Valid From">
                    <DatePicker
                      placeholder="Valid From"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col span={5}>
                  <Form.Item name={["validTo"]} label="Valid To">
                    <DatePicker
                      placeholder="Valid To"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    name={["value"]}
                    label="Value"
                    rules={[{ required: true, message: "Amount Required" }]}
                  >
                    <Input type="number" placeholder="Value" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col>
                  <Form.Item name={["currency", "id"]}>
                    <Input hidden></Input>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Add;
